import { Card } from "@fdr-mar/promos-types/Component";
import { StoreCPPPromosAction } from "./types";

export const storeCPPPromotions = (
  promotions: Card[]
): StoreCPPPromosAction => ({
  type: "STORE_CPP_PROMOS",
  payload: promotions
});
